<template>
  <div id="mainApp">
    <mainMenu v-if="!notFoundFlag" :menu-list="menuConfig" v-model="isCollapse" />
    <div v-if="!notFoundFlag" class="layoutMain" :class="{ 'isCollapse': isCollapse }">
      <div class="header">
        <div class="headerTitle">
          <img v-if="lang === 'zh-CN'" src="@/assets/images/systemNameZH.png">
          <img v-else src="@/assets/images/systemNameEN.svg">
        </div>
        <el-dropdown trigger="click" @command="userSelection" style="float:right;">
          <span class="el-dropdown-link">
            <span>
              <span>{{ userInfo.sysUser.userName }}</span>
              <span v-if="userInfo.userType === 'qd'" style="margin-left: 10px">{{ userInfo.sysUser.userId }}</span>
            </span>
            <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown" style="margin-top:-3px">
            <el-dropdown-item command="switchUser" v-if="userInfo.permissionDTO.allowswitchUser">
              {{ $t('home.userSwitch') }}</el-dropdown-item>
            <div v-if="userInfo.permissionDTO.leadModule.hasPermissionUseLead">
              <el-dropdown-item v-for="(item, index) in roleList" :key="index" :command="item.roleId"
                :icon="item.isDefaultRole ? 'el-icon-check' : ''">
                {{ item.roleName }}
              </el-dropdown-item>
            </div>
            <el-dropdown-item command="signOut">{{ $t('home.logOut') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="userAvatar">
          <div>
            <img :src="userInfo.userAvatar ? userInfo.userAvatar : defaultPhoto">
          </div>
        </div>
        <!-- <span class="score" @click="feedback">{{ $t('home.suggestion') }}</span>
        <span class="splitLine">|</span> -->
        <span class="lang">
          <vue-i18n />
        </span>
        <span class="business">{{ $t('home.technical') }}</span>
        <!--<span class="business">业务支持:刘娟娟 15364009798</span>-->
      </div>
      <div class="content">
        <el-scrollbar class="contentScrollbar">
          <keep-alive :include="keepAliveList">
            <router-view :key="$route.fullPath" />
          </keep-alive>
        </el-scrollbar>
      </div>
    </div>
    <subLoading v-show="subPageLoading" class="common_subLoading" />
    <!--<commonGuidePage :image-list="guidePageImage" :guide-page-show="guidePageShow" @closeHandlen="guidePageClose" />-->
    <!--<guidePageBtn ref="guidePageBtn" @guideBtnHandle="guideBtnHandle" v-show="guidePageBtnShow" />-->
    <switchUserDialog :switch-user-dialog-visible="switchUserDialogVisible"
      @dialogCloseHandle="switchUserDialogClose" />
    <router-view v-if="notFoundFlag" />
  </div>
</template>
<script>
import { subLoading } from '@rui-jie/rjelement-components';
import { mapState, mapActions } from 'vuex';
import defaultPhoto from '@/assets/images/touxiang.png';
import commonGuidePage from '@/components/commonGuidePage';
import guidePageBtn from '@/components/guidePageBtn';
import switchUserDialog from '@/components/switchUserDialog';
import { LoginState} from "rj-common-framework";
import mainMenu from '@/components/mainMenu';
import { commonServer } from '@/API/home';
import VueI18n from '@/components/i18n'
// 1.进入页面第一步 debugger;
export default {
  data() {
    // 3.进入页面第三步 debugger;
    return {
      notFoundFlag: false,
      defaultPhoto: defaultPhoto,
      guidePageImage: [
        // require('assets/images/homeGuidePage1.png'),
        // require('assets/images/homeGuidePage2.png'),
        // require('assets/images/homeGuidePage3.png'),
        // require('assets/images/homeGuidePage4.png')
      ],
      guidePageShow: false,
      guidePageBtnShow: false,
      guidebubbleBoxShow: false,
      switchUserDialogVisible: false,
      roleList: [],
      isCollapse: false,
      lang: localStorage.getItem('lang') || "zh-CN"
    };
  },
  components: {
    // 'rj-layout': layout,
    subLoading,
    // commonGuidePage,
    // guidePageBtn,
    switchUserDialog,
    mainMenu,
    VueI18n
  },
  watch: {
    $route(to, from) {
      let toPath = to.path;
      // 面包屑处理
      if (to.meta.level) {
        let breadcrumbList = JSON.parse(JSON.stringify(this.$store.state.breadcrumbList));
        // 判断是前进还是后退
        let fromLevel = from.meta.level ? from.meta.level : 0;
        if (to.meta.level > fromLevel) {
          let targetInfo = {
            path: to.path,
            name: to.meta.name,
            i18nName: to.meta.name
          };
          if (to.query && Object.keys(to.query).length > 0) targetInfo.query = to.query;
          breadcrumbList.push(targetInfo);
        } else {
          breadcrumbList.splice(breadcrumbList.length - 1);
        }
        this.$store.commit('setBreadcrumbList', breadcrumbList.map(item => {
          return {...item, name: this.$t(item.i18nName)}
        }));
      } else {
        this.$store.commit('setBreadcrumbList', [{ path: to.path, i18nName: to.meta.name, name: to.meta.name ? this.$t(to.meta.name) : '' }]);
      }
      // 404 401页面处理
      if (toPath === '/404' || toPath === '/401' || toPath === '/maintenancePage' || toPath === '/qdSignContract' || toPath === '/qdSignContractDetail') {
        this.notFoundFlag = true;
      } else {
        this.notFoundFlag = false;
      }

      // 引导页处理
      // switch (toPath) {
      //   case '/home':
      //     this.guidePageImage = [
      //       require('assets/images/homeGuidePage1.png'),
      //       require('assets/images/homeGuidePage2.png'),
      //       require('assets/images/homeGuidePage3.png'),
      //       require('assets/images/homeGuidePage4.png')
      //     ];
      //     this.guidePageBtnShow = true;
      //     this.cacheHandlen('homeGuidePage');
      //     break;
      //   case '/newApplicationForm':
      //     this.guidePageImage = [
      //       require('assets/images/newApplicationGuidePage1.png'),
      //       require('assets/images/newApplicationGuidePage2.png'),
      //       require('assets/images/newApplicationGuidePage3.png'),
      //       require('assets/images/newApplicationGuidePage4.png'),
      //       require('assets/images/newApplicationGuidePage5.png'),
      //       require('assets/images/newApplicationGuidePage6.png'),
      //       require('assets/images/newApplicationGuidePage7.png'),
      //       require('assets/images/newApplicationGuidePage8.png')
      //     ];
      //     this.guidePageBtnShow = true;
      //     this.cacheHandlen('newApplicationGuidePage');
      //     break;
      //   default:
      //     this.guidePageShow = false;
      //     this.guidePageBtnShow = false;
      // }
    }
  },
  computed: {
    ...mapState({
      subPageLoading: state => state.subPageLoading,
      userInfo: state => state.userInfo,
      menuConfig: state => state.routerMenu.menuConfig,
      keepAliveList: state => state.keepAliveList
    })
  },
  methods: {
    ...mapActions(['getUserInfo']),
    userSelection(val) {
      if (val === 'signOut') {
        this.signOut();
      } else if (val === 'switchUser') {
        this.switchUserDialogVisible = true;
      } else {
        commonServer.switchRole(val).then(res => {
          if (res.status === '200') {
            let url = `${window._env_.VUE_APP_BASEURL}/home`;
            location.replace(url);
          }
        });
      }
    },
    switchUserDialogClose() {
      this.switchUserDialogVisible = false;
    },
    getCookie(cName) {
      if (document.cookie.length > 0) {
        let cStart = document.cookie.indexOf(cName + '=');
        if (cStart !== -1) {
          cStart = cStart + cName.length + 1;
          let cEnd = document.cookie.indexOf(';', cStart);
          if (cEnd === -1) cEnd = document.cookie.length;
          return unescape(document.cookie.substring(cStart, cEnd));
        }
      }
      return '';
    },
    delCookie() {
      var date = new Date();
      date.setTime(date.getTime() - 10000);
      let val = this.getCookie('phplogin');
      document.cookie = 'phplogin=' + val + ';Domain=.ruijie.com.cn;Path=/;expires=' + date.toGMTString();
      // LoginState.logOut();
    },
    signOut() {
      // 退出登录
      this.$store.commit('setSubPageLoading', true);
        let reurl = window.location.href;
         if (reurl.indexOf('rjmms') > 0) {
            LoginState.logOut();
         }else{
           commonServer.signOut().then(res => {
            this.delCookie();
            if (res.status === '200') {
              window.location.href = 'https://was.ruijie.com.cn/as-service/auth/authorize?type=qdlogin&reurl=' + reurl;
            }
            this.$store.commit('setSubPageLoading', false);
           });
         }
    },
    feedback() {
      window.open('http://ruijiemoa.mikecrm.com/KUOUez2');
    },
    guidePageClose() {
      this.guidePageShow = false;
      if (this.guidebubbleBoxShow) {
        this.$refs.guidePageBtn.bubbleTimerStart();
      }
      this.guidebubbleBoxShow = false;
    },
    guideBtnHandle() {
      this.guidePageShow = true;
    },
    cacheHandlen(key) {
      if (localStorage.getItem(key) !== '1') {
        localStorage.setItem(key, '1');
        this.guidePageShow = true;
        this.guidebubbleBoxShow = true;
      }
    }
  },
  mounted() {
    let { state } = this.$store;
    if (state.userInfo.permissionDTO.leadModule.hasPermissionUseLead) {
      this.roleList = state.userInfo.permissionDTO.leadModule.roleList;
    }
    if (!state.breadcrumbList || state.breadcrumbList.length < 1) {
      this.$store.commit(
        'setBreadcrumbList',
        JSON.parse(sessionStorage.getItem('breadcrumbList'))
      );
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(
        'breadcrumbList',
        JSON.stringify(state.breadcrumbList)
      );
    });
    this.$store.dispatch('getPendingApprovalNum');
  }
};
</script>
<style lang="scss">
@import "style/main";
@import "style/common";

.header {
  >.el-dropdown-menu {
    left: auto !important;
    right: 10px;
  }
}

#mainApp {
  width: 100%;
  height: 100%;
  background: #f0f4fa;
  overflow: hidden;

  >.layoutMain {
    position: absolute;
    top: 0;
    left: 230px;
    right: 0;
    bottom: 0;
    transition: left 0.3s ease-in-out;

    &.isCollapse {
      left: 64px;
    }

    >.header {
      height: 60px;
      line-height: 60px;
      padding-right: 16px;
      background: #313D4A;
      overflow: hidden;
      border-left: 1px solid #3f4a58;
      border-bottom: 1px solid #29313d;
      @extend .clear;

      >.headerTitle {
        width: auto;
        height: 22px;
        padding-left: 16px;
        float: left;

        >img {
          height: 100%;
          vertical-align: middle;
        }
      }

      >span {
        float: right;
        font-size: 14px;
        color: #9CA4AC;
      }

      >.splitLine {
        margin: 0 10px;
      }

      >.score {
        margin-right: 16px;
        font-weight: 400;
        cursor: pointer;
      }

      >.userAvatar {
        float: right;
        height: 60px;
        display: flex;
        margin-right: 7px;
        align-items: center;

        >div {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          overflow: hidden;
          text-align: center;

          >img {
            width: 100%;
          }
        }
      }

      .headerInformation {
        &:after {
          content: "";
          display: block;
          clear: both;
        }
      }

      .el-dropdown {
        color: #9CA4AC;
        cursor: pointer;
      }

      .lang {
        margin: 0 10px;
      }
    }

    >.content {
      width: 100%;
      position: absolute;
      top: 60px;
      bottom: 0;

      >.contentScrollbar {
        width: 100%;
        height: 100%;

        >.el-scrollbar__wrap {
          overflow-x: hidden;

          >.el-scrollbar__view {
            padding: 20px;
          }
        }

        >.is-horizontal>.el-scrollbar__thumb {
          background: #FFFFFF;
          opacity: 0;
        }
      }
    }
  }

  >.common_subLoading {
    >.mark {
      z-index: 6666;
    }

    >.loading-box {
      z-index: 6666;
    }
  }
}
</style>
